import React from 'react';
import styled from 'styled-components';

export const InputField = styled.input`
  border: 1px solid #000;
  padding: 13px 13px 11px;
  font-family: inherit;
  font-size: inherit;
  color: #000;
  transition: box-shadow 0.15s ease-in-out;

  &:focus {
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
    border: 1px solid #000;
  }
`;
